var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiNorOtpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25673_9117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05282 16H11.3044C12.1046 16 12.7557 15.2351 12.7557 14.2951V1.70492C12.7557 0.764882 12.1046 0 11.3044 0H5.05282C4.25265 0 3.60156 0.764882 3.60156 1.70492V14.2951C3.60156 15.2351 4.25254 16 5.05282 16V16ZM9.94564 0.786885C9.90926 1.11264 9.82932 1.32799 9.7751 1.39883H6.58245C6.52823 1.32798 6.44799 1.11264 6.41191 0.786885H9.94564ZM4.2715 1.70492C4.2715 1.1987 4.62205 0.786885 5.05295 0.786885H5.73861C5.8011 1.51289 6.05787 2.18571 6.54149 2.18571H9.81604C10.2999 2.18571 10.5564 1.51289 10.6189 0.786885H11.3046C11.7355 0.786885 12.086 1.1987 12.086 1.70492V14.2951C12.086 14.8013 11.7355 15.2131 11.3046 15.2131H5.053C4.6221 15.2131 4.27155 14.8013 4.27155 14.2951L4.2715 1.70492Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4.40918,
    width: 16.1106,
    height: 6.26522,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5615 4.95844V10.4507H0.549262V4.95844H15.5615ZM15.5615 4.40918H0.549262C0.245967 4.40918 0 4.65501 0 4.95844V10.4507C0 10.754 0.245829 11 0.549262 11H15.5615C15.8648 11 16.1108 10.7542 16.1108 10.4507V4.95844C16.1108 4.65515 15.8648 4.40918 15.5615 4.40918Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.95496,
    cy: 7.65808,
    r: 1.27136,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.04871,
    cy: 7.65808,
    r: 1.27136,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1464,
    cy: 7.65808,
    r: 1.27136,
    fill: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25673_9117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiNorOtpIcon);
export default __webpack_public_path__ + "static/media/PINorOTPIcon.871f35c83c6d7143c59a55f4c5e6ef2c.svg";
export { ForwardRef as ReactComponent };